import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.div`
  display: inline-block;
  width: 24px;
  height: 24px;

  &::after {
    content: "";
    color: #2b97be;
    display: block;
    width: 20px;
    height: 20px;
    margin: 3px;
    border-radius: 50%;
    border: 3px solid currentColor;
    border-color: currentColor transparent currentColor transparent;
    animation: ${rotate} 1s linear infinite;
  }
`;
